<div class="container-fluid h-100">
  <div class="styles-body h-100">
    <div class="panel panel-default body-space">
      <div class="panel-body content-body-pages">
        <app-frontend-filter (onFiltersChanged)="onFiltersChanged($event)"
                             [filters]="allFilters">
        </app-frontend-filter>
        <div class="user-panel-default">
          <div class="card-table">
            <div class="d-flex justify-content-end head-table">
              <app-frontend-button (click)="onCreateClicked()"
                                   [Image]="true"
                                   [class]="'card-main'"
                                   [endpoint]="ServicePath.CREATE_ATTRIBUTE"
                                   [src]="'/icons/add2.svg'"
                                   [title]="'Insert'">
              </app-frontend-button>
            </div>
            <div class="card-body-table">
              <app-frontend-table [dataSource]="roles"
                                  [displayColumnEndpoints]="displayEndPoint"
                                  [displayColumnTypes]="displayColumnTypes"
                                  [displayColumns]="displayedColumns"
                                  [displayDataSources]="displayDataSources"
                                  [tableProperties]="tableProperties">
              </app-frontend-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
